import { Feature } from '@common-stack/server-core';
import { preferences } from './preferences';
import { interfaces } from 'inversify';
import { TYPES } from './constants';
import { goModule } from './containers';

const createGoServiceFunc = (container: interfaces.Container) => ({
  go: container.get(TYPES.LANGUAGE_TYPE_GO),
});

export default new Feature({
  createContainerFunc: goModule,
  createPreference: preferences,
  createServiceFunc: createGoServiceFunc,
} as any);
